import Loader from '@/components/ui/Loader'
// import Divider from 'components/ui/Divider'
import { fetcher } from 'api/swr'
import { type FC } from 'react'
import { useParams } from 'react-router-dom'
import useSWR from 'swr'
import { ColorGrid } from './ColorGrid'
import { ToningPicker } from './ToningPicker'
import type { Toning } from './types'

const ToningConfig: FC = () => {
  const { tid } = useParams<{ tid: string }>()
  const { data: tonings, isLoading } = useSWR<Toning[]>(
    ['/tonings', { tid }],
    fetcher,
  )

  if (isLoading) return <Loader>Load tonings...</Loader>

  return (
    <>
      <ToningPicker tonings={tonings} />
      {/* <Divider /> */}
      <ColorGrid tonings={tonings} />
    </>
  )
}

export default ToningConfig
